import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
@Injectable({
  providedIn: 'root'
})
export class divisionsService {
  displayedColumns: string[] = ['nombre', 'descripcion', 'estatus', 'opciones'];
  constructor(private _http: HttpClient) { }
  
  async getDivisions(){
    let promise = new Promise((resolve, reject) => {
      this._http
        .get(environment.API_URL + "/groups")
        .toPromise()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
    return promise;
  }
}
